export default __webpack_public_path__ + "static/media/cross-grey.40ad2bc1.svg";